import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"font-size":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" App Kosten: ")
const _hoisted_3 = { style: {"color":"var(--ion-headline-color)","padding-right":"0"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Weitere Informationen zur Berechnung")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"small","font-weight":"300"},
  class: "ion-padding ion-text-justify",
  slot: "content"
}, [
  /*#__PURE__*/_createTextVNode(" Diese Kalkulation ist nur eine grobe Schätzung auf Basis der gemachten Angaben. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Da App-Projekte oft sehr individuell sind, können nicht alle Aspekte im Kalkulator beachtet werden und der echte Preis kann abweichen. ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_row, { style: {"padding-top":"30px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          size: "12",
          style: {"padding-left":"0"},
          class: "ion-text-center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("span", _hoisted_3, " ca. " + _toDisplayString(new Intl.NumberFormat('de-DE', { style: 'decimal' }).format(_ctx.store.data.calcBudgetLow)) + " € - " + _toDisplayString(new Intl.NumberFormat('de-DE', { style: 'decimal' }).format(_ctx.store.data.calcBudgetHigh)) + " € ", 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          size: "0",
          "size-md": "1",
          "size-xl": "2"
        }),
        _createVNode(_component_ion_col, {
          size: "12",
          "size-md": "10",
          "size-xl": "8"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_accordion_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_accordion, { value: "first" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, { slot: "header" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_ion_col, {
          size: "0",
          "size-md": "1",
          "size-xl": "1"
        })
      ]),
      _: 1
    })
  ], 64))
}